var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9231 11.2143H12.9281L9.08231 5.85714H10.3077L10.8846 5.32143V1.03571L10.3077 0.5H5.69231L5.11538 1.03571V5.32143L5.69231 5.85714H6.91769L3.07192 11.2143H1.07692L0.5 11.75V14.9643L1.07692 15.5H4.53846L5.11538 14.9643V11.75L4.53846 11.2143H4.46L8 6.28571L11.54 11.2143H11.4615L10.8846 11.75V14.9643L11.4615 15.5H14.9231L15.5 14.9643V11.75L14.9231 11.2143ZM6.26923 4.78571V1.57143H9.73077V4.78571H6.26923ZM3.96154 12.2857V14.4286H1.65385V12.2857H3.96154ZM14.3462 14.4286H12.0385V12.2857H14.3462V14.4286Z",
    fill: "#1D2433"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShare);
export default __webpack_public_path__ + "static/media/logoShare.575f05d08c3e6ba6ed716ede70f7ce53.svg";
export { ForwardRef as ReactComponent };